import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimengModule } from '@gestor-web/app/shared/modules';
import { BlendusPipesModule } from '@gestor-web/app/shared/pipes/pipes.module';
import { AgViewsToolpanelComponent } from './ag-views-toolpanel.component';

@NgModule({
  declarations: [AgViewsToolpanelComponent],
  imports: [CommonModule, FormsModule, PrimengModule, BlendusPipesModule],
  exports: [AgViewsToolpanelComponent],
})
export class AgViewsToolpanelModule {}
